import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { LocationOn, MailOutline, Phone } from '../../../lib/assets/icons/SVG-Icons'

const FooterForLab = () => {
  return (
    <section className="flex justify-center bg-[#111928] ">
      <div className="px-8 sm:px-12 md:px-18 lg:px-24 xl:px-25 max-screen:px-0 py-6 md:py-10 xl:py-20 max-w-7xl">
        <div className="w-full flex flex-col justify-between items-center gap-5 xl:gap-16">
          <div className="w-full flex flex-col md:grid md:grid-cols-3 items-start justify-center gap-5 sm:gap-8 md:gap-14 lg:gap-20">
            <div className="w-full flex flex-col items-center text-start gap-4 lg:gap-4">
              <div className="w-full flex justify-center md:justify-start">
                <Link to="/">
                  <img
                    src="https://blog-bucket.s3.brilliant.com.bd/fileavatar/020feabd-df9d-43fd-befa-7a20a64d26a2.png"
                    alt=""
                    className="w-32 xl:w-40 h-auto"
                  />
                </Link>
              </div>
              <div className="w-full lg:pr-12 flex flex-col items-center justify-start gap-4 xl:gap-6">
                <p className="text-[#DCD4E7] text-xs xl:text-base text-center sm:text-left font-hindi xl:leading-6">
                  বাংলা ভাষায় সফটওয়্যার ইঞ্জিনিয়ারিং এর নানান টপিকে পরিধি নিয়ে আসছে চমৎকার সব কোর্স।
                  আপনিও সামিল হতে পারেন পরিধির পরিবারে, আর নিজের শেখার ইচ্ছাকে করে তুলতে পারেন
                  আনন্দের।
                </p>
                <div className="w-full hidden lg:flex items-center justify-start gap-4 xl:gap-5">
                  <Link to="https://www.facebook.com/poridhi.io" target="_blank">
                    <FontAwesomeIcon
                      icon={faFacebook}
                      className="text-[#DCD4E7] w-4 h-4 xl:w-6 xl:h-6"
                    />
                  </Link>
                  <Link to="https://www.instagram.com/poridhiio/" target="_blank">
                    <FontAwesomeIcon
                      icon={faInstagram}
                      className="text-[#DCD4E7] w-4 h-4 xl:w-6 xl:h-6"
                    />
                  </Link>
                  <Link to="https://www.linkedin.com/company/poridhiio" target="_blank">
                    <FontAwesomeIcon
                      icon={faLinkedin}
                      className="text-[#DCD4E7] w-4 h-4 xl:w-6 xl:h-6"
                    />
                  </Link>
                  <Link
                    to="https://api.whatsapp.com/send?phone=%2B8801760440444&data=ARCArOPfcesZGgySwRQA90m8ztaPC6Ppzp9nzMdmvpH3mMcBe8-YSxCk1SQvxEnfNdxbx9euLIpvhYDh4F5wjYcfpogU0UdG-Ckzxfs_u_53elpzuySvtA4bpPKy7XXLsUJJc0KPZvMHwukowMcag6NNrQ&source=FB_Page&app=facebook&entry_point=page_cta"
                    target="_blank">
                    <FontAwesomeIcon
                      icon={faWhatsapp}
                      className="text-[#DCD4E7] w-4 h-4 xl:w-6 xl:h-6"
                    />
                  </Link>
                </div>
              </div>
            </div>

            <div className="w-full flex flex-col items-center justify-center text-center md:text-left gap-2 xl:gap-6 md:pl-8 lg:pl-16">
              <p className="w-full font-hindi not-italic font-bold leading-normal text-xl xl:text-2xl text-[#DCD4E7]">
                কোম্পানি
              </p>
              <div className="w-full flex flex-col items-center md:items-start justify-center font-hindi text-xs xl:text-base not-italic text-[#DCD4E7] gap-2 xl:gap-4">
                <Link
                  to="/about-us"
                  className="hover:text-[#8940F8] hover:transition hover:duration-200">
                  আমাদের সম্পর্কে
                </Link>

                <Link
                  to="/privacy-policy"
                  className="hover:text-[#8940F8] hover:transition hover:duration-200">
                  প্রাইভেসি পলিসি
                </Link>
                <Link
                  to="/refund-policy"
                  className="hover:text-[#8940F8] hover:transition hover:duration-200">
                  রিফান্ড পলিসি
                </Link>
                <Link
                  to="/terms-and-conditions"
                  className="hover:text-[#8940F8] hover:transition hover:duration-200">
                  টার্মস ও শর্তাবলী
                </Link>
              </div>
            </div>

            <div className="w-full flex flex-col items-center md:items-start text-center  md:text-left gap-2 xl:gap-6">
              <p className="w-full font-hindi not-italic font-bold leading-normal text-xl xl:text-2xl text-[#DCD4E7]">
                যোগাযোগ
              </p>
              <div className="w-4/5 flex flex-col items-center justify-center md:justify-start font-hindi text-xs xl:text-base not-italic text-[#DCD4E7] gap-2 xl:gap-4">
                <div className="w-full flex justify-center md:justify-start items-center gap-2 ">
                  <MailOutline className="hidden xl:block" />
                  <p className="xl:grow">poridhi.io.ltd@gmail.com</p>
                </div>
                <div className="w-full flex justify-center md:justify-start items-center gap-2">
                  <Phone className="hidden xl:block" />
                  <p className="xl:grow">+880 1760-440444</p>
                </div>
                <div className="w-full flex justify-center md:justify-start gap-2">
                  <LocationOn className="hidden xl:block" />
                  <p className="xl:grow">
                    32, Metropolitan Housing <br />
                    Co-operative Society, <br />
                    Mohammadpur, Dhaka-1207 <br />
                    (TRAD/DNCC/009542/2023)
                  </p>
                </div>
              </div>
            </div>
          </div>
          <figure className="w-full">
            <img src="/Payment Banner.png" alt="" className="aspect-auto w-full" />
          </figure>
          <div className="w-full flex flex-col justify-center items-center">
            <div className="font-inter not-italic tracking-wide text-xs xl:text-base text-center text-[#DCD4E7]">
              Copyright © 2018-{new Date().getFullYear()}{' '}
              <span className="font-semibold text-[#DCD4E7]">Poridhi</span> All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FooterForLab
